import React from "react";
import { default as WPopover } from "@mui/material/Popover";

function Popover(props) {
  return <WPopover {...props} />;
}

export default Popover;
